import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import CustomIcon from '../../common/CustomIcon';

const styles = {
  primaryColorBar: {
    backgroundColor: '#58bf6e !important' // $green2
  },
  secondaryColorBar: {
    backgroundColor: '#bf7358 !important'
  }
};

class ProgressBarButtons extends React.Component {
  static propTypes = {
    colors: PropTypes.object,
    pauseRestartIcon: PropTypes.string,
    index: PropTypes.string,
    handlePauseRestart: PropTypes.func,
    handleCancel: PropTypes.func
  };

  render() {
    const { colors /* , pauseRestartIcon, handlePauseRestart */, index, handleCancel } = this.props;

    return (
      <Fragment>
        {/* <CustomIcon
          key={`${pauseRestartIcon}-${index}`}
          name={pauseRestartIcon}
          classes='manage-download-icons'
          onClick={handlePauseRestart}
          size={16} color={colors.primary} />, */}

        <CustomIcon
          key={`cancel-${index}`}
          name="cancel-button"
          size={16}
          onClick={handleCancel}
          color={colors.primary}
          classes="manage-download-icons"
        />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    colors: state.theme.colors,
    contentBooks: state.content.contentBooks,
    activitiesContent: state.content.activitiesContent
  };
}

export default connect(mapStateToProps)(injectSheet(styles)(ProgressBarButtons));
